import React from 'react';

const StepperHeader = ({ currentStep, onStepClick, isStepComplete }) => {
  const steps = [
    {
      id: 1,
      name: 'المعلومات',
      description: 'بيانات الدورة الأساسية',
      status: currentStep === 1 ? 'current' : isStepComplete(1) ? 'complete' : 'incomplete'
    },
    {
      id: 2,
      name: 'الخيارات',
      description: 'خيارات الدورة',
      status: currentStep === 2 ? 'current' : isStepComplete(2) ? 'complete' : 'incomplete'
    },
    {
      id: 3,
      name: 'الجدولة',
      description: 'تواريخ البدء والانتهاء',
      status: currentStep === 3 ? 'current' : isStepComplete(3) ? 'complete' : 'incomplete'
    },
    {
      id: 4,
      name: 'المدربون',
      description: 'مدربو الدورة',
      status: currentStep === 4 ? 'current' : isStepComplete(4) ? 'complete' : 'incomplete'
    }
  ];

  return (
    <>
      <style>
        {`
          .stepper-line {
            right: calc(49% + 2rem);
            width: 90%;
          }
          .stepper-container {
            position: relative;
            z-index: 0;
            padding: 0 2rem;
          }
          .stepper-circle {
            right: calc(50% - 5px);
            border-radius: 9999px;
          }
          .stepper-text {
            margin-top: 0.75rem;
            margin-right: 30px;
          }
          @keyframes numberFadeIn {
            0% { transform: scale(0); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .number-animation {
            animation: numberFadeIn 0.3s ease-out forwards;
          }
          .step-incomplete {
            border-color: #9CA3AF;
            background-color: #F3F4F6;
          }
        `}
      </style>
      <nav aria-label="Progress" className="stepper-container">
        <ol role="list" className="flex items-center">
          {steps.map((step, stepIdx) => (
            <li key={step.name} className={`${
              stepIdx === 0 ? 'relative flex-1 ml-4' :
              stepIdx === 1 ? 'relative flex-1 ml-4' :
              stepIdx === 2 ? 'relative flex-1 ml-4' :
              'relative flex-1 ml-5'
            }`}>
              <div className="group relative">
                {stepIdx !== steps.length - 1 && (
                  <span 
                    className={`absolute top-4 stepper-line h-0.5 ${
                      step.status === 'complete' ? 'bg-blue-600 dark:bg-blue-500' : 'bg-gray-200 dark:bg-gray-700'
                    }`} 
                    aria-hidden="true" 
                  />
                )}
                
                <button
                  onClick={() => onStepClick(step.id)}
                  className={`relative z-10 flex h-8 w-8 items-center justify-center stepper-circle cursor-pointer ${
                    step.status === 'complete' ? 'border-blue-600 bg-blue-600 dark:border-blue-500 dark:bg-blue-500 hover:bg-blue-700' :
                    step.status === 'current' ? 'border-blue-600 bg-white dark:border-blue-500 dark:bg-gray-800' :
                    'step-incomplete hover:bg-gray-100'
                  } border-2`}
                >
                  {step.status === 'complete' ? (
                    <svg className="h-4 w-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <span className={`${step.status === 'current' ? 'number-animation' : ''}`}>
                      {step.status === 'current' ? (
                        <span className="h-2.5 w-2.5 rounded-full bg-blue-600 dark:bg-blue-500" />
                      ) : (
                        <span className="text-sm font-medium text-gray-500">
                          {step.id}
                        </span>
                      )}
                    </span>
                  )}
                </button>

                <div className="mt-3 text-center stepper-text">
                  <span className="block text-sm font-medium text-gray-900 dark:text-white">
                    {step.name}
                  </span>
                  <span className="block text-sm text-gray-500 dark:text-gray-400">
                    {step.description}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default StepperHeader;
